/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { GameModelDto } from '../models/game-model-dto';
import { GamePbpModelDto } from '../models/game-pbp-model-dto';
import { gameTrackerControllerCreateGame } from '../fn/game-tracker/game-tracker-controller-create-game';
import { GameTrackerControllerCreateGame$Params } from '../fn/game-tracker/game-tracker-controller-create-game';
import { gameTrackerControllerCreateGamePbp } from '../fn/game-tracker/game-tracker-controller-create-game-pbp';
import { GameTrackerControllerCreateGamePbp$Params } from '../fn/game-tracker/game-tracker-controller-create-game-pbp';
import { gameTrackerControllerDeleteGame } from '../fn/game-tracker/game-tracker-controller-delete-game';
import { GameTrackerControllerDeleteGame$Params } from '../fn/game-tracker/game-tracker-controller-delete-game';
import { gameTrackerControllerDeleteGamePbp } from '../fn/game-tracker/game-tracker-controller-delete-game-pbp';
import { GameTrackerControllerDeleteGamePbp$Params } from '../fn/game-tracker/game-tracker-controller-delete-game-pbp';
import { gameTrackerControllerGetGamePbp } from '../fn/game-tracker/game-tracker-controller-get-game-pbp';
import { GameTrackerControllerGetGamePbp$Params } from '../fn/game-tracker/game-tracker-controller-get-game-pbp';
import { gameTrackerControllerGetGamePbpById } from '../fn/game-tracker/game-tracker-controller-get-game-pbp-by-id';
import { GameTrackerControllerGetGamePbpById$Params } from '../fn/game-tracker/game-tracker-controller-get-game-pbp-by-id';
import { gameTrackerControllerGetGames } from '../fn/game-tracker/game-tracker-controller-get-games';
import { GameTrackerControllerGetGames$Params } from '../fn/game-tracker/game-tracker-controller-get-games';
import { gameTrackerControllerUpdateGame } from '../fn/game-tracker/game-tracker-controller-update-game';
import { GameTrackerControllerUpdateGame$Params } from '../fn/game-tracker/game-tracker-controller-update-game';
import { gameTrackerControllerUpdateGameLocalConnectionInfo } from '../fn/game-tracker/game-tracker-controller-update-game-local-connection-info';
import { GameTrackerControllerUpdateGameLocalConnectionInfo$Params } from '../fn/game-tracker/game-tracker-controller-update-game-local-connection-info';
import { gameTrackerControllerUpdateGamePbp } from '../fn/game-tracker/game-tracker-controller-update-game-pbp';
import { GameTrackerControllerUpdateGamePbp$Params } from '../fn/game-tracker/game-tracker-controller-update-game-pbp';
import { gameTrackerControllerUploadGamePbpCut } from '../fn/game-tracker/game-tracker-controller-upload-game-pbp-cut';
import { GameTrackerControllerUploadGamePbpCut$Params } from '../fn/game-tracker/game-tracker-controller-upload-game-pbp-cut';
import { gameTrackerControllerUploadGamePbpCutConfirm } from '../fn/game-tracker/game-tracker-controller-upload-game-pbp-cut-confirm';
import { GameTrackerControllerUploadGamePbpCutConfirm$Params } from '../fn/game-tracker/game-tracker-controller-upload-game-pbp-cut-confirm';
import { PlayByPlayModelDto } from '../models/play-by-play-model-dto';

@Injectable({ providedIn: 'root' })
export class GameTrackerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `gameTrackerControllerGetGames()` */
  static readonly GameTrackerControllerGetGamesPath = '/game-tracker/games';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gameTrackerControllerGetGames()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerControllerGetGames$Response(params?: GameTrackerControllerGetGames$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GameModelDto>>> {
    return gameTrackerControllerGetGames(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gameTrackerControllerGetGames$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerControllerGetGames(params?: GameTrackerControllerGetGames$Params, context?: HttpContext): Observable<Array<GameModelDto>> {
    return this.gameTrackerControllerGetGames$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GameModelDto>>): Array<GameModelDto> => r.body)
    );
  }

  /** Path part for operation `gameTrackerControllerCreateGame()` */
  static readonly GameTrackerControllerCreateGamePath = '/game-tracker/games';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gameTrackerControllerCreateGame()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  gameTrackerControllerCreateGame$Response(params: GameTrackerControllerCreateGame$Params, context?: HttpContext): Observable<StrictHttpResponse<GamePbpModelDto>> {
    return gameTrackerControllerCreateGame(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gameTrackerControllerCreateGame$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  gameTrackerControllerCreateGame(params: GameTrackerControllerCreateGame$Params, context?: HttpContext): Observable<GamePbpModelDto> {
    return this.gameTrackerControllerCreateGame$Response(params, context).pipe(
      map((r: StrictHttpResponse<GamePbpModelDto>): GamePbpModelDto => r.body)
    );
  }

  /** Path part for operation `gameTrackerControllerUpdateGame()` */
  static readonly GameTrackerControllerUpdateGamePath = '/game-tracker/games/{uuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gameTrackerControllerUpdateGame()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  gameTrackerControllerUpdateGame$Response(params: GameTrackerControllerUpdateGame$Params, context?: HttpContext): Observable<StrictHttpResponse<GamePbpModelDto>> {
    return gameTrackerControllerUpdateGame(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gameTrackerControllerUpdateGame$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  gameTrackerControllerUpdateGame(params: GameTrackerControllerUpdateGame$Params, context?: HttpContext): Observable<GamePbpModelDto> {
    return this.gameTrackerControllerUpdateGame$Response(params, context).pipe(
      map((r: StrictHttpResponse<GamePbpModelDto>): GamePbpModelDto => r.body)
    );
  }

  /** Path part for operation `gameTrackerControllerDeleteGame()` */
  static readonly GameTrackerControllerDeleteGamePath = '/game-tracker/games/{uuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gameTrackerControllerDeleteGame()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerControllerDeleteGame$Response(params: GameTrackerControllerDeleteGame$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return gameTrackerControllerDeleteGame(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gameTrackerControllerDeleteGame$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerControllerDeleteGame(params: GameTrackerControllerDeleteGame$Params, context?: HttpContext): Observable<void> {
    return this.gameTrackerControllerDeleteGame$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `gameTrackerControllerUpdateGameLocalConnectionInfo()` */
  static readonly GameTrackerControllerUpdateGameLocalConnectionInfoPath = '/game-tracker/games/{uuid}/local-connection-info';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gameTrackerControllerUpdateGameLocalConnectionInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerControllerUpdateGameLocalConnectionInfo$Response(params: GameTrackerControllerUpdateGameLocalConnectionInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<GamePbpModelDto>> {
    return gameTrackerControllerUpdateGameLocalConnectionInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gameTrackerControllerUpdateGameLocalConnectionInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerControllerUpdateGameLocalConnectionInfo(params: GameTrackerControllerUpdateGameLocalConnectionInfo$Params, context?: HttpContext): Observable<GamePbpModelDto> {
    return this.gameTrackerControllerUpdateGameLocalConnectionInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<GamePbpModelDto>): GamePbpModelDto => r.body)
    );
  }

  /** Path part for operation `gameTrackerControllerGetGamePbp()` */
  static readonly GameTrackerControllerGetGamePbpPath = '/game-tracker/games/{uuid}/pbp';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gameTrackerControllerGetGamePbp()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerControllerGetGamePbp$Response(params: GameTrackerControllerGetGamePbp$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PlayByPlayModelDto>>> {
    return gameTrackerControllerGetGamePbp(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gameTrackerControllerGetGamePbp$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerControllerGetGamePbp(params: GameTrackerControllerGetGamePbp$Params, context?: HttpContext): Observable<Array<PlayByPlayModelDto>> {
    return this.gameTrackerControllerGetGamePbp$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PlayByPlayModelDto>>): Array<PlayByPlayModelDto> => r.body)
    );
  }

  /** Path part for operation `gameTrackerControllerCreateGamePbp()` */
  static readonly GameTrackerControllerCreateGamePbpPath = '/game-tracker/games/{uuid}/pbp';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gameTrackerControllerCreateGamePbp()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  gameTrackerControllerCreateGamePbp$Response(params: GameTrackerControllerCreateGamePbp$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayByPlayModelDto>> {
    return gameTrackerControllerCreateGamePbp(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gameTrackerControllerCreateGamePbp$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  gameTrackerControllerCreateGamePbp(params: GameTrackerControllerCreateGamePbp$Params, context?: HttpContext): Observable<PlayByPlayModelDto> {
    return this.gameTrackerControllerCreateGamePbp$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayByPlayModelDto>): PlayByPlayModelDto => r.body)
    );
  }

  /** Path part for operation `gameTrackerControllerGetGamePbpById()` */
  static readonly GameTrackerControllerGetGamePbpByIdPath = '/game-tracker/games/{uuid}/pbp/{pbpUuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gameTrackerControllerGetGamePbpById()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerControllerGetGamePbpById$Response(params: GameTrackerControllerGetGamePbpById$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayByPlayModelDto>> {
    return gameTrackerControllerGetGamePbpById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gameTrackerControllerGetGamePbpById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerControllerGetGamePbpById(params: GameTrackerControllerGetGamePbpById$Params, context?: HttpContext): Observable<PlayByPlayModelDto> {
    return this.gameTrackerControllerGetGamePbpById$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayByPlayModelDto>): PlayByPlayModelDto => r.body)
    );
  }

  /** Path part for operation `gameTrackerControllerUpdateGamePbp()` */
  static readonly GameTrackerControllerUpdateGamePbpPath = '/game-tracker/games/{uuid}/pbp/{pbpUuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gameTrackerControllerUpdateGamePbp()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  gameTrackerControllerUpdateGamePbp$Response(params: GameTrackerControllerUpdateGamePbp$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayByPlayModelDto>> {
    return gameTrackerControllerUpdateGamePbp(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gameTrackerControllerUpdateGamePbp$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  gameTrackerControllerUpdateGamePbp(params: GameTrackerControllerUpdateGamePbp$Params, context?: HttpContext): Observable<PlayByPlayModelDto> {
    return this.gameTrackerControllerUpdateGamePbp$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayByPlayModelDto>): PlayByPlayModelDto => r.body)
    );
  }

  /** Path part for operation `gameTrackerControllerDeleteGamePbp()` */
  static readonly GameTrackerControllerDeleteGamePbpPath = '/game-tracker/games/{uuid}/pbp/{pbpUuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gameTrackerControllerDeleteGamePbp()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerControllerDeleteGamePbp$Response(params: GameTrackerControllerDeleteGamePbp$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return gameTrackerControllerDeleteGamePbp(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gameTrackerControllerDeleteGamePbp$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerControllerDeleteGamePbp(params: GameTrackerControllerDeleteGamePbp$Params, context?: HttpContext): Observable<void> {
    return this.gameTrackerControllerDeleteGamePbp$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `gameTrackerControllerUploadGamePbpCut()` */
  static readonly GameTrackerControllerUploadGamePbpCutPath = '/game-tracker/games/{uuid}/pbp/{pbpUuid}/upload-cut';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gameTrackerControllerUploadGamePbpCut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  gameTrackerControllerUploadGamePbpCut$Response(params: GameTrackerControllerUploadGamePbpCut$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayByPlayModelDto>> {
    return gameTrackerControllerUploadGamePbpCut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gameTrackerControllerUploadGamePbpCut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  gameTrackerControllerUploadGamePbpCut(params: GameTrackerControllerUploadGamePbpCut$Params, context?: HttpContext): Observable<PlayByPlayModelDto> {
    return this.gameTrackerControllerUploadGamePbpCut$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayByPlayModelDto>): PlayByPlayModelDto => r.body)
    );
  }

  /** Path part for operation `gameTrackerControllerUploadGamePbpCutConfirm()` */
  static readonly GameTrackerControllerUploadGamePbpCutConfirmPath = '/game-tracker/games/{uuid}/pbp/{pbpUuid}/upload-cut-confirm';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gameTrackerControllerUploadGamePbpCutConfirm()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerControllerUploadGamePbpCutConfirm$Response(params: GameTrackerControllerUploadGamePbpCutConfirm$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayByPlayModelDto>> {
    return gameTrackerControllerUploadGamePbpCutConfirm(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gameTrackerControllerUploadGamePbpCutConfirm$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  gameTrackerControllerUploadGamePbpCutConfirm(params: GameTrackerControllerUploadGamePbpCutConfirm$Params, context?: HttpContext): Observable<PlayByPlayModelDto> {
    return this.gameTrackerControllerUploadGamePbpCutConfirm$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayByPlayModelDto>): PlayByPlayModelDto => r.body)
    );
  }

}
